import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Rewards: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--rewards')}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M12,20 C7.581722,20 4,16.418278 4,12 C4,10.268936 4.55170127,8.62004085 5.5577939,7.25596267 C7.05644516,5.22406479 9.42657812,4 12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 Z M12,19 C15.8659932,19 19,15.8659932 19,12 C19,8.13400675 15.8659932,5 12,5 C9.76397257,5 7.6845948,6.05711655 6.36257286,7.84953728 C5.47619821,9.05129971 5,10.4944426 5,12 C5,15.8659932 8.13400675,19 12,19 Z M14.4235026,12.8249936 L15.2982813,16.7378426 L12,14.6605798 L8.7017187,16.7378426 L9.57649742,12.8249936 L6.68883264,10.214644 L10.4944322,9.87773901 L12,6.17100907 L13.5055678,9.87773901 L17.3111674,10.214644 L14.4235026,12.8249936 Z M12,13.6100913 L13.9648456,14.8475543 L13.4429507,12.5131401 L15.2047534,10.9205311 L12.8863416,10.715285 L12,8.53309906 L11.1136584,10.715285 L8.79524664,10.9205311 L10.5570493,12.5131401 L10.0351544,14.8475543 L12,13.6100913 Z"
        id="Rewards_S"
        fill="#000000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default Rewards;
